import { updateLink } from '@/shared/utils/seo/update-link';

export default ({ $router }) => {
  const metaRobots = document.querySelector('#metaRobots');

  $router.afterEach((to) => {
    if (to.meta && to.meta.noindex) {
      metaRobots.content = 'noindex, nofollow';
    } else {
      metaRobots.content = 'index, follow';
    }

    // TODO: change watch to proper label: https://jira.atendesoftware.pl/browse/SOFAMBBO-5902
    updateLink('/watch' + to.path.split('#')[0]);
  });
};
